// extracted by mini-css-extract-plugin
export default {"cards-wrapper":"subCategoryStyles_cards-wrapper__SmRkY"};